import type { FC } from 'react';

import { Button } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import styles from './web-site-button.module.scss';

interface IWebsiteButtonProps {
  link: string;
}

export const WebsiteButton: FC<IWebsiteButtonProps> = ({ link }) => {
  const isMobile = useIsMobile();

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    window.open(link, '_blank', 'noopener');
  };

  return (
    <Button onClick={handleClick} variant="primary" size={44} block={isMobile} className={styles.button}>
      Перейти на сайт
    </Button>
  );
};
